export default __webpack_public_path__ + "static/media/duster-colour-6.8a2b2eac.jpg";